export const translation = {
    title: 'Manage Jobs',
    management: 'Jobs',
    jobType: 'Job Type',
    dashboard: {
        title: 'Dashboard',
        jobName: 'Job Name',
        jobType: 'Job Type',
        jobRun: 'Job Run #{{value}}',
        audit: {
            title: 'Audit',
            modifiedTables: 'Modified Tables',
            queryId: 'Query Id',
            queries: 'Queries',
            showQueries: 'Show Queries',
            parseWarning: 'We were unable to extract references from this SQL statement: {{message}}',
            returnedValue: 'Returned Value',
            storedProceduresCalled: 'Stored Procedures Called',
            usedTables: 'Used Tables',
            referencedTables: 'Referenced Tables',
            warehouseName: 'Warehouse Name',
            warehouseSize: 'Warehouse Size',
            warehouseType: 'Warehouse Type'
        },
        modificationType: {
            ALTER: 'Altered',
            COPY_INTO: 'Copied Into',
            CREATE: 'Created',
            DELETE: 'Deleted',
            DROP: 'Dropped',
            GRANT: 'Granted',
            INSERT: 'Inserted Into',
            MERGE: 'Merged',
            SELECT: 'Referenced',
            TRUNCATE: 'Truncated',
            UNDROP: 'Undropped',
            UPDATE: 'Updated/Edited'
        },
        status: {
            running: 'Running',
            succeeded: 'Succeeded',
            succeeded_with_warnings: 'Succeeded with warnings',
            failed: 'Failed',
            skipped: 'Skipped',
            canceled: 'Canceled',
            canceling: 'Canceling',
            unknown: 'Unknown'
        },
        deleted: '{{- name}} (Deleted)',
        insufficientData: '+/- Insufficient Data',
        filtersCount_one: '{{count}} Filter applied',
        filtersCount_other: '{{count}} Filters applied',
        lastDays_one: 'Last Day ({{period}})',
        lastDays_other: 'Last {{count}} Days ({{period}})',
        metadata: {
            title: 'Execution Metadata',
            tableOwner: 'Table Owner',
            lastAltered: 'Last Altered',
            lastDdl: 'Last DDL',
            lastDdlBy: 'Last DDL By',
            comment: 'Comment',
            queryId: 'Query ID',
            sessionId: 'Session ID',
            queryTag: 'Query Tag',
            exectionStatus: 'Execution Status',
            startTime: 'Start Time',
            endTime: 'End Time',
            totalElapsed: 'Total Elapsed Time',
            bytesScanned: 'Bytes Scanned',
            rowsParsed: 'Rows Parsed',
            rowsProduced: 'Rows Produced',
            rowsDropped: 'Rows dropped',
            inputBytes: 'Input Bytes',
            outputBytes: 'Output Bytes',
            outputFilesCount: 'Output Files Count',
            filesProcessed: 'Files Processed',
            loadStatus: 'Status',
            showAll: 'Show all…',
            showSql: 'Show SQL…',
            showExecutionMetadata: 'Show Execution Metadata'
        },
        cancel: {
            label: 'Cancel Job Run',
            succeeded: 'Job successfully canceled.',
            failed: 'Unable to cancel job.'
        },
        overview: {
            title: 'By the Numbers',
            highestErrorRates: 'Highest Error Rates',
            jobsRun: 'Jobs Run',
            longestJobRuntimes: 'Longest Job Runtimes',
            medianDuration: 'Median Duration',
            mostJobsRun: 'Most Jobs Run',
            mostRecordsGenerated: 'Most Records Generated',
            recordsGenerated: 'Records Generated',
            jobRunFailures: 'Job Run Failures'
        },
        timeline: {
            title: 'Timeline',
            empty_runs: 'No jobs have run within the last 6 hours.',
            empty_defs: 'There are no jobs configured in your system.<br /><action>Create one here</action> to start seeing it in the timeline.',
            period: 'Showing Time Period [{{fromTime}} to {{toTime}}]'
        },
        sqlQuery: {
            title: 'SQL Query'
        }
    },
    definitions: {
        title: 'Job Definitions',
        create: 'Create new job…',
        search: 'Type to find a job definition…',
        deployment: 'Deployment',
        target: 'Target Table',
        environment: 'Environment',
        description_placeholder: 'Describe your job…',
        environment_placeholder: 'Select job environment…',
        project_placeholder: 'Select project…',
        output: 'Output Node',
        output_placeholder: 'Select output…',
        triggerType: 'Trigger Type',
        scheduled: 'Scheduled',
        eventDriven: 'Event-Driven',
        eventDrivenTrigger_one: '{{count}} Event-Driven Trigger',
        eventDrivenTrigger_other: '{{count}} Event-Driven Triggers',
        mapTo: 'Map to…',
        sourceTableMapping: 'Source Mapping',
        storedProcedure: 'Stored Procedure',
        version: 'Version',
        incremental: 'Incremental Materialization',
        version_placeholder: 'Enter version…',
        database_placeholder: 'Enter database…',
        database_select: 'Select database…',
        database_loading: 'Loading databases…',
        schema_placeholder: 'Enter schema…',
        table_placeholder: 'Enter table…',
        name_placeholder: 'Enter a name for your job…',
        tag_placeholder: 'Select tag…',
        model_placeholder: 'Select model…',
        edit: 'Edit job…',
        delete: 'Delete job…',
        APIKeyUsageHelp: {
            title: 'API Trigger Setup and Help',
            info: 'The API Key should be treated as a secure credential and should never be checked into source control.',
            sampleScript: 'Sample CURL Script',
            subtitle: 'To trigger this Job ({{jobName}}) externally via the API:',
            steps: {
                step1: 'Create or acquire an existing <action>API Token</action> for authenticating your external app.',
                step2: 'Embed the API Token in HTTP call as <strong>Authorization</strong> header:',
                step3: 'Trigger via HTTP API with POST request to following URI with authorization headers. The request parameters can be set in the body or the query string. If a callback url is provided, a webhook notification will be sent to this address once the job completes. Trigger Conditions can be skipped by setting "skipChecks" to true.',
                step4: 'Extract <strong>statusUrl</strong> of the resulting Job Run from the response:',
                step5: 'Query the status via HTTP GET request from <strong>statusUrl</strong> with the same authorization headers:'
            }
        },
        jobType: {
            exportToCloud: 'Unload to Cloud Storage Job',
            importFromCloud: 'Load from Cloud Storage Job',
            storedProcedure: 'Stored Procedure Job',
            system: 'System Job',
            modelJob: '$t(common:model) Job'
        },
        jobTypeLabel: {
            exportToCloud: 'Unload to Cloud',
            importFromCloud: 'Load from Cloud',
            storedProcedure: 'Stored Proc',
            modelJob: 'Model'
        },
        run: {
            label: 'Run Job Now',
            skipChecks: 'Skip trigger conditions',
            hint: 'Ad-hoc job runs will not affect any defined execution trigger.',
            succeeded: 'Job "{{- name}}" successfully submitted.',
            succeeded_one: '{{count}} Job successfully submitted.',
            succeeded_other: '{{count}} Jobs successfully submitted.',
            failed: 'Unable to submit job "{{- name}}".',
            failed_one: 'Unable to submit {{count}} Job.',
            failed_other: 'Unable to submit {{count}} Jobs.',
            failed_skipped: 'One or more trigger conditions not met for job.',
            failed_skipped_one: 'One or more trigger conditions not met for {{count}} job.',
            failed_skipped_other: 'One or more trigger conditions not met for {{count}} jobs.'
        },
        createMenu: {
            dbt: 'DBT Indexing Job',
            storedProcedure: 'Stored Procedure Job',
            exportToCloud: 'Export: Unload to Cloud Storage',
            importFromCloud: 'Import: Load from Cloud Storage',
            modelJob: '$t(common:model) Job'
        },
        errors: {
            duplicateName: 'Job names must be unique'
        }
    },
    environments: {
        title: 'Environments',
        create: 'Create new environment…',
        search: 'Type to find an environment…',
        connection: 'Snowflake Connection Details',
        environmentAttributes: 'Environment Attributes',
        environmentDefaults: 'Environment Defaults',
        edit: 'Edit environment…',
        delete: 'Delete environment…',
        empty: 'No environments available. Click below to create one.'
    },
    dialogs: {
        environment: {
            title_create: 'Create New Environment',
            title_edit: 'Edit Environment',
            panelTitle: 'Configure Environment',
            account: 'Snowflake Identity',
            attributes: 'Environment Attributes',
            channel: 'Slack Channel',
            descriptionPlaceholder: 'Describe your environment…',
            serviceAccount: 'Service Account',
            namePlaceholder: 'Enter a name for your environment…',
            notifications: 'Slack Notifications',
            selectExistingAccount: 'Select an existing service account…',
            envDefaults: 'Environment Defaults',
            invalidIdentity: 'Snowflake Identity must be provided to enable this section',
            invalidForm: 'Snowflake Identity, and Environment Attributes must be provided to enable this section',
            selectDatabase: 'Select Database…',
            selectSchema: 'Select Schema…',
            selectRole: 'Select Role…',
            selectWarehouse: 'Select Warehouse…'
        },
        definition: {
            manual: 'Manual',
            disabled_trigger_message: 'The job will be executed on an ad-hoc basis, as needed by the User.',
            enable_trigger: 'Enable Job Trigger',
            scheduled: 'Scheduled',
            target: 'Target',
            trigger: 'Trigger Configuration',
            title_create: 'Create New Job Definition',
            title_edit: 'Edit Job Definition',
            titleDBTIndexingJob_create: 'Create New DBT Indexing Job',
            titleDBTIndexingJob_edit: 'Edit DBT Indexing Job',
            titleSnowflakeHistoryIndexingJob_create: 'Create Snowflake Query History Indexing Job',
            titleSnowflakeHistoryIndexingJob_edit: 'Edit Snowflake Query History Indexing Job',
            titleMetricsJob_create: 'Create New Metrics Job',
            titleMetricsJob_edit: 'Edit Metrics Job',
            titleLoadJob_create: 'Create New Import (Load from Cloud Storage) Job',
            titleLoadJob_edit: 'Edit Import (Load from Cloud Storage) Job',
            titleUnloadJob_create: 'Create New Export (Unload to Cloud Storage) Job',
            titleUnloadJob_edit: 'Edit Export (Unload to Cloud Storage) Job',
            modelJob_create: 'Create New $t(common:model) Job',
            modelJob_edit: 'Edit $t(common:model) Job',
            incrementalColumns: 'Select column(s) to create a unique key for each record:',
            incrementalDisabled: 'Incremental Materialization can only be used with Table targets.',
            required: 'Required: {{number}} of {{total}}',
            conditions: 'Source Trigger Conditions',
            jobConditions: 'Data Quality',
            modelJob: {
                trigger: 'Trigger',
                conditions: 'Datasource Freshness',
                details: 'Details'
            },
            datasourceFreshnessHint: 'Run Datasource Freshness checks before running job',
            dataQualityHint: 'Run Model Data Quality checks before running job',
            dqSourceModelsHeading: 'Source Model Quality Checks',
            dqSourceModelsEmpty: 'No Datasources have Model Data Quality checks configured for this job.',
            dqSourceModelsToggle: "Run job only when {{name}}'s Data Quality checks pass",
            dqCurrentModelHeading: 'This Model ({{name}}) Source Data Quality Checks',
            dqCurrentModelToggle: "Run job only when this model's ({{name}}) Source Data Quality checks pass",
            dqCurrentModelSummary: 'This model ({{name}}) passes all source quality checks',
            dqThisModel: 'This Model',
            moreRecent: 'Run job only when table data is more recent than {{duration}}',
            quantity: 'Value',
            quantity_placeholder: 'Value (e.g. 6)',
            unit: 'Unit',
            unit_placeholder: 'Select time unit',
            details: 'Job Details',
            sourceTableMappingWarning: 'No longer valid due to source table mapping.',
            conditionSummary: '{{fqn, wordbreak}} {{summaries, list}}',
            conditionSummaries: '{{summaries, list, capitalize}}',
            selectEnv: 'Select Environment to enable this section',
            selectDb: 'Select a Database to see available stored procedures.'
        },
        deleteJob: {
            title: 'Delete Job',
            prompt: 'Are you sure you want to <strong>permanently delete</strong> job "{{- name}}"?',
            confirm: 'Delete Job',
            succeeded: 'Job "{{- name}}" successfully deleted!',
            failed: 'Unable to delete job "{{- name}}".'
        },
        deleteEnv: {
            title: 'Delete Environment',
            prompt_zero: 'Are you sure you want to <strong>permanently delete</strong> environment "{{- name}}"?',
            prompt_one: '"{{- name}}" has <strong>{{count}} job</strong> associated with it. Please delete the job first.',
            prompt_other: '"{{- name}}" has <strong>{{count}} jobs</strong> associated with it. Please delete all jobs first.',
            confirm: 'Delete Environment',
            succeeded: 'Environment "{{- name}}" successfully deleted!',
            failed: 'Unable to delete environment "{{- name}}".'
        },
        deleteServiceAccount: {
            title: 'Delete Service Account',
            prompt: 'Are you sure you want to <strong>permanently delete</strong> service account "{{- name}}"?',
            confirm: 'Delete Service Account',
            succeeded: 'Service account "{{- name}}" successfully deleted!',
            failed: 'Unable to delete service account "{{- name}}".'
        },
        serviceAccount: {
            title_create: 'Create New Service Account',
            title_edit: 'Edit Service Account',
            namePlaceholder: 'Enter a name for your service account…',
            descriptionPlaceholder: 'Describe your service account…',
            attributes: 'Attributes'
        }
    },
    serviceAccounts: {
        title: 'Service Accounts',
        create: 'Create new service account…',
        delete: 'Delete account…',
        edit: 'Edit account…',
        search: 'Type to find a service account…'
    },
    storedProcedureJob: {
        title_create: 'Create New Stored Procedure Job',
        title_edit: 'Edit Stored Procedure Job',
        argumentSignature: 'Argument Signature',
        noParams: 'There are no parameters to configure',
        paramsPlaceholder: 'Enter value…',
        returnType: 'Return type',
        selectStoredProcedure: 'Stored procedure',
        typeNotSupported: 'Token "{{type}}" is not supported.',
        findJobTriggerPlaceholder: 'Type to find a job…',
        runWhenJobIsExecuted: 'Run when Job is executed…',
        runWhenDeployedTableIsExecuted: 'Run when Deployed Table is executed…',
        scheduledJobRepeats: 'Scheduled Job repeats…',
        sourceCount: '{{all}} sources',
        filteredSourcesCount: '{{filtered}} of {{all}} sources',
        selectTriggerSource: 'Select a job as the trigger source.',
        noJobsFound: 'Sorry, no jobs found.',
        jobsWithInputTables: 'Jobs with Input Tables ({{count}})',
        otherJobs: 'All Other Jobs ({{count}})'
    },
    SnowflakeHistoryIndexingJob: {
        enabled: 'Snowflake Query History Indexing Job is enabled',
        notConfigured: 'Snowflake Query History Indexing Job is not configured',
        destinationTable: 'Destination Table'
    },
    TableMetricsJob: {
        enabled: 'Table ROI Job is enabled',
        notConfigured: 'Table ROI Job is not configured',
        destinationTable: 'Destination Table',
        destinationTableInfo: "The table written to the schema will be called {{table}}. Choose a Database and Schema that can be read by the user's who will be using the Table ROI Dashboards.",
        name: 'Collect ROI Table Metrics',
        description: 'This job collects both query and runtime metrics for tables managed by Datameer. Once enabled, we will be able to provide data around the Total Cost of Ownership (TCO) for each managed table. Giving you insight into how each table is used versus how much it costs to maintain.',
        metrics: {
            managedTablesCount: 'Managed Tables',
            newReads: 'Tracked queries',
            newWrites: 'Tracked jobs'
        },
        snowflakeHistoryIndexingNotConfigured: 'Need to first enable the Snowflake History indexing job!'
    },
    WarehouseUsageJob: {
        enabled: 'Warehouse Usage Job is enabled',
        notConfigured: 'Warehouse Usage Job is not configured',
        destinationTable: 'Destination Table',
        destinationTableInfo: "The table written to the schema will be called {{table}}. Choose a Database and Schema that can be read by the user's who will be using the Table TCO Dashboards.",
        name: 'Collect Warehouse Usage',
        description: 'This job collects warehouse usage metrics.'
    },
    UnloadJob: {
        syntaxDocumentation: 'Snowflake Syntax Documentation',
        fields: {
            stageTitle: 'Snowflake Stage',
            roleLabel: 'Showing only stages based on role defined in selected Environment: {{role}}',
            stageLoading: 'Loading Snowflake Stages…',
            stagePlaceholder: 'Select Snowflake Stage',
            noStagesFound: 'No stages found for role {{role}}.',
            pathSuffix: 'Path Suffix (Optional)',
            rootPath: 'Root Path',
            fileFormatsTitle: 'Snowflake File Format',
            fileFormatsLoading: 'Loading Snowflake File Formats…',
            fileFormatsPlaceholder: 'Select File Format',
            fileFormatValue: '{{name}} ({{type}})',
            fileFormatDefaultValue: 'As defined in Stage ({{name}})',
            partition: {
                title: 'Partition by (Optional)',
                helpLabel: 'Any expression which evaluates to String',
                expression: 'Expression',
                value_none: 'None',
                value_date: 'BY CURRENT DATE',
                value_dateHour: 'BY CURRENT DATE and HOUR',
                value_custom: 'Custom'
            }
        },
        loadingModal: {
            title: 'Please be patient',
            message: 'Evaluating Stage selection'
        }
    },
    LoadJob: {
        foundFiles_one: 'Found {{count}} file',
        foundFiles_other: 'Found {{count}} files',
        fields: {
            tableNameTitle: 'Table Name',
            destinationTitle: 'Select Load Schema',
            destinationHelp: 'Showing only schemas based on role defined in selected Environment: {{role}}',
            patternTitle: 'Regular Expression (Optional)',
            fileFormatOptionsTitle: 'Format type overwrite options',
            schemaTitle: 'Columns',
            rawDataTitle: 'Raw Data',
            copyOptionsTitle: 'Copy Options (Optional)',
            skippedRecordsLabel: 'Dropped records in table <tableName />',
            abortJobOnFileFormatChanges: 'Abort Job when File Format has changed.',
            replaceIfExists: {
                label: 'Import Mode',
                appendOption: 'Append Data',
                replaceOption: 'Replace Data',
                warning: 'This will replace an existing table and cannot be undone.'
            }
        }
    },
    emptyResults: {
        title: 'No results available.',
        dashboard: 'Try different filters to see available Job Runs',
        environments_allUsers: 'Try a different role or search to see available Environments',
        environments_admin: 'Try a different search to see available Environments',
        jobs_allUsers: 'Try a different role or search to see available Jobs',
        jobs_admin: 'Try a different search to see available Jobs',
        serviceAccounts_allUsers: 'Try a different role or search to see available Service Accounts',
        serviceAccounts_admin: 'Try a different search to see available Service Accounts',
        tooOld: 'Selected Job Run is more than 30 days old.'
    },
    model: {
        visibleJobs: 'Jobs Definitions <span>visible for {{role}}</span>',
        targetTag: 'Target Tag',
        updateToTargetTag: 'Update to Target Tag',
        updateJobsToTag: 'Update Selected Jobs to Target Tag',
        updateJobsToTag_select: 'Select Jobs to Update',
        runSelectedJobs_one: 'Run Job Now',
        runSelectedJobs_other: 'Run Selected Jobs Now',
        runSelectedJobs_select: 'Select Jobs to Run',
        runSelectedJobsMessage_one: 'Ad-hoc job runs will not affect any defined execution trigger.',
        runSelectedJobsMessage_other: 'Ad-hoc job runs will not affect any defined execution trigger. Run trigger conditions for the selected jobs below:',
        skipChecks: 'Skip trigger conditions',
        jobStatus: 'Job is up to date with target version. ({{targetTagVersion}})',
        jobStatus_ahead: 'Job is configured with newer version ({{currentTagVersion}}) than target ({{targetTagVersion}}).',
        jobStatus_behind: 'Job is configured with older version ({{currentTagVersion}}) than target ({{targetTagVersion}}).',
        jobStatus_configIssues: 'Job has configuration issues. Click "Edit Job" below to fix.',
        jobStatusApply_cleanly: 'Version {{targetTagVersion}} will apply cleanly.',
        jobStatusApply_notCleanly: 'Version {{targetTagVersion}} may not apply cleanly. Click "Edit Job" below to fix.',
        summary: {
            freshness: 'is less than {{duration}} {{unit, lowercase}} old',
            quality: 'passes data quality checks'
        },
        sourceQuality: 'Source Quality Checks Enabled',
        invalidChapter: {
            FRESHNESS_CHECK_TABLE_MISSING: 'Invalid Trigger Conditions',
            INCREMENTAL_REFRESH_KEY_COLUMN_MISSING: 'Invalid Incremental Materialization',
            SOURCE_TABLE_MAPPING_TABLE_MISSING: 'Invalid Source Table Mapping',
            TRIGGER_SOURCE_JOB_DELETED: 'Invalid Trigger Configuration'
        },
        jobStatusTooltop: {
            GOOD: 'Job is up to date',
            GOOD_one: '{{count}} job is up to date',
            GOOD_other: '{{count}} jobs are up to date',
            STALE: 'Job is out of date',
            STALE_one: '{{count}} job is out of date',
            STALE_other: '{{count}} jobs are out of date',
            POTENTIALLY_BROKEN: 'Job is potentially broken',
            POTENTIALLY_BROKEN_one: '{{count}} job is potentially broken',
            POTENTIALLY_BROKEN_other: '{{count}} jobs are potentially broken',
            BROKEN: 'Job is broken',
            BROKEN_one: '{{count}} job is broken',
            BROKEN_other: '{{count}} jobs are broken'
        },
        manageJobs: 'Manage Jobs…',
        noJobs: 'There are no jobs associated with the $t(common:model)'
    }
};
